export default {
  getListForm (root) {
    return {
      id: (new Date()).getTime(),
      isAutoLoad: true,
      isAsyncUpdate: false,
      store: {
        get: {
          url: null, // String => 'Certs/GetAllDynamic'
          selected: null, // [String, Array] => 'id,title' | ['id', 'title']
          filters: null, // String => 'field == "sdsd"',
          orderBy: { // Using if does not using a sort by columns
            field: null, // column field
            order: null // string asc || desc
          },
          expand: null // Boolean
        },
        create: {
          url: null
        },
        patch: {
          url: null,
          method: 'patch'
        },
        delete: {
          url: null,
          modal: {
            msgTemplate: null,
            msgDataKey: 'title'
          }
        },
        mainField: 'id'
      },
      autoSave: {
        isAutoSave: true,
        url: null
      },
      header: {
        isVisible: true,
        title: {
          isVisible: true,
          value: null
        },
        controls: {
          isVisible: true,
          addNew: {
            isVisible: true,
            title: root.L10n('add-new'),
            permission: null
          }
        }
      },
      content: {
        isScroll: true
      },
      export: {
        excel: {
          name: null,
          columns: []
        }
      },
      group: {
        isAvailable: false,
        field: 'id'
      },
      footer: {
        isVisible: false,
        pagination: {
          isVisible: false,
          current: 1,
          total: 0,
          size: 3,
          sizes: {
            isVisible: true,
            values: [
              { label: '3', value: 3 },
              { label: '5', value: 5 },
              { label: '8', value: 8 }
            ]
          }
        }
      },
      controls: {
        isVisible: true,
        list: [
          {
            type: 'save',
            permission: null
          },
          {
            type: 'delete',
            permission: null
          }
        ]
      },
      permission: {
        edit: false // inline edit, save, delete
      }
    }
  },
  gerExportExcel (root) {
    return {
      title: '', // title of column
      field: '', // field name
      width: 15, // width cell
      type: 's',
      filter: null // TODO
    }
  }
}
